/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/EditLocation/Content/SaveAction",
  onSubmit,
  isSubmitting
  
}) {
let editLocationSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_location',
})
let editLocationIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'edit_location',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 data="edit_location"
 onClick={editLocationSubmitData}
 disabled={editLocationIsSubmittingData}
 text="Save"
/>
{children}
</React.Fragment>)
}